import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const CheckoutSubscriptionSuccessPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-l from-[#ffd76a] via-[#ffdba1] to-[#75eff3] flex items-start justify-center p-6">
      <div className="bg-white shadow-2xl rounded-2xl max-w-xl w-full p-10 text-center">
        <div className="flex justify-center">
          <CheckCircleIcon className="h-20 w-20 text-papayaTitle" />
        </div>

        <h1 className="text-4xl font-bold text-gray-800 mt-4">
          {t("subscriptionSuccess.thank_you", "Merci pour votre abonnement !")}
        </h1>

        <p className="mt-4 text-lg text-gray-600">
          {t(
            "subscriptionSuccess.subscription_confirmed",
            "Votre abonnement a été confirmé avec succès."
          )}
        </p>

        <div className="mt-6 text-3xl animate-bounce">🎉</div>

        <p className="mt-6 text-base text-gray-700 font-medium">
          {t("subscriptionSuccess.enjoy", "Profitez bien de vos avantages !")}
        </p>

        {sessionId && (
          <p className="mt-4 text-sm text-gray-500">
            Session ID: <span className="font-mono">{sessionId}</span>
          </p>
        )}

        <button
          onClick={() => navigate("/")}
          className="mt-8 inline-block bg-papayaTitle hover:bg-papayaText text-white px-6 py-3 rounded-full font-semibold transition"
        >
          {t("subscriptionSuccess.back_home", "Retour à l'accueil")}
        </button>
      </div>
    </div>
  );
};

export default CheckoutSubscriptionSuccessPage;
